import React, { useState } from 'react';
import { TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { TableCustom } from '../../../../components/common';
import useDebounce from '../../../../hooks/useDebounce';

interface IPart {
  _id?: string;
  spare_part_name: string | null;
  spare_part_desc: string | null;
  // used_for_machine: string | null;
  // opening_stock_qty: number | null;
  opening_stock_UOM: string | null;
  min_stock_qty: number | null;
  max_stock_qty: number | null;
  reorder_level: number | null;
  // closing_stock_qty: number | null;
  // location: string | null;
  remarks: string | null;
}
const tableHeaderObj = [
  [
    { text: 'S.No.', rowspan: 1, colspan: 1 },
    { text: 'Name', rowspan: 1, colspan: 1 },
    { text: 'Description', rowspan: 1, colspan: 1 },
    { text: 'UOM', rowspan: 1, colspan: 1 },
    { text: 'Minimum Qty', rowspan: 1, colspan: 1 },
    { text: 'Maximum Qty', rowspan: 1, colspan: 1 },
    { text: 'Reorder Level', rowspan: 1, colspan: 1 },
    { text: 'Remarks', rowspan: 1, colspan: 1 },
    // { text: 'ACTION', rowspan: 1, colspan: 1 },
  ],
];

// const filterOptions = [
//   { value: 'createdAt', name: 'Most Recent' },
//   { value: 'spare_part_desc', name: 'A-Z' },
// ];

const ViewSparePartList = ({
  moduleId,
}: //   closeModal,
{
  moduleId?: any;
  //   closeModal?: any;
}) => {
  const [partData, setPartData] = useState<IPart[]>([]);

  const navigate = useNavigate();

  const fetchPartData = () => {
    if (!moduleId) return;
    axios
      .get(`/api/machineRoutes/sparePartsForMachine/${moduleId}`)
      .then((res) => {
        setPartData(res.data);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchPartData, 300, []);
  return (
    <>
      {/* <StateCustomTable
        filterOptions={filterOptions}
        {...{ search, setSearch, filter, setFilter }}
        label="Search By ERP And Spare Part "
      > */}
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {partData &&
            partData.map((item: IPart, index: number) => (
              <React.Fragment key={item?._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{item.spare_part_name}</TableCell>
                  <TableCell align="center">{item.spare_part_desc}</TableCell>
                  <TableCell align="center">{item.opening_stock_UOM}</TableCell>
                  <TableCell align="center">{item.min_stock_qty}</TableCell>
                  <TableCell align="center">{item.max_stock_qty}</TableCell>
                  <TableCell align="center">{item.reorder_level}</TableCell>
                  <TableCell align="center">{item.remarks}</TableCell>
                  {/* <TableCell align="center">
                    {sparePartIds && handleUpdateSparePart && (
                      <Checkbox
                        checked={sparePartIds.includes(item._id || '')}
                        onChange={() => handleUpdateSparePart(item._id || '')}
                      />
                    )}
                  </TableCell> */}
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      {/* <CustomPagination totalPage={totalPages} /> */}
      {/* </StateCustomTable> */}
    </>
  );
};

export default ViewSparePartList;
